<i class="k-icon k-font-icon k-i-close dialog-close" (click)="onClose()"></i>
<div class="container-fluid">
  <div class="row">
    <div class="container">
      <div class="dialog-title">Delete User</div>
      <p class="py-2">
        Are you sure you want to permanently remove
        <strong>{{ user.firstName }} {{ user.lastName }}</strong> from the
        Portal?
      </p>
      <cyborg-error *ngIf="error" [error]="error"></cyborg-error>
      <button
        themeColor="primary"
        class="dialog-button"
        size="large"
        (click)="onDelete()"
        kendoButton
      >
        Delete
      </button>
    </div>
  </div>
</div>
